<template>
    <div>
        <b-overlay :show="loading" rounded="sm">
            <b-row class="mt-4">
                <b-col cols="12">
                    <b-form bg-variant="light">
                        <b-col class="dd">
                            <b-form-select class="form-control" id="input-role_id" v-model="model.role_id" :options="roles"
                                text-field="name" value-field="id" required trim>
                                <template #first>
                                    <b-form-select-option :value="null" disabled>{{ $translate('select_the_role')
                                    }}</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-col>
                    </b-form>
                </b-col>
                <b-col cols="12" class="my-2 my-mb-0 text-end">
                    <b-button :disabled="!isRoleAvailable" size="sm" variant="info" @click="saveRole">
                        {{ $translate('add_role') }}
                    </b-button>
                </b-col>
            </b-row>
            <b-card-body>
                <b-table striped hover :items="typeRoles" :fields="itemFields">
                    <template #cell(id)="{ item }">
                        <b-button variant="pink-button" @click="deleteRole(item)">
                            <img src="@/assets/images/icon/delete.svg">
                        </b-button>
                    </template>
                </b-table>
            </b-card-body>
        </b-overlay>
    </div>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
export default {
    mixins: [popupMixins],
    data() {
        return {
            model: {
                id: null,
                role_id: null,
            },
            loading: false,
            itemModal: false,
            modelChanged: false,
        }
    },
    computed: {
        itemFields() {
            return [
                {
                    key: 'id',
                    label: this.$translate('actions'),
                },

                {
                    key: 'role_id',
                    label: this.$translate('role'),
                    formatter: (value, key, item) => item.role.name,
                },
            ]
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },

        roles() {
            return this.$store.state.roles.items
        },

        checkoffType() {
            return this.$store.state.checkoffTypes.selectedType
        },

        typeRoles() {
            const roles = this.checkoffType.checkoff_type_roles || []
            console.log('checkoff type', roles)
            return roles
        },
        isRoleAvailable() {
            return (
                this.model.role_id &&
                !this.typeRoles.some(x => x.role_id === this.model.role_id)
            )
        },
    },
    watch: {},

    methods: {
        async viewRole(id) {
            /* if the template exists find the item among the template's 
            types otherwise, firnd the item among the template model's types */
            const templateType =
                this.template.types.find(x => x.id === id) || {}
            this.model = { ...templateType }
            this.itemModal = true
        },
        async deleteRole(item) {
            console.log("itemmmm", item)
            // if the template exists delete the master item from the database
            const id = item.id
            const path = `checkoffTypes/deleteRole`
            const checkoff_type_id = this.checkoffType.id
            const title = `${this.$translate('delete_checkoffType_role')}`
            const message = `${this.$translate('delete_note')} ${item.role.name}?`

            const result = await this.confirmMessage(title, message)
            if (result) {
                this.loading = true
                await this.$store
                    .dispatch(path, { checkoff_type_id, id })
                    .then(() => {
                        this.loading = false
                        this.itemModal = false
                        this.modelChanged = false
                        this.doToast(
                            this.$translate('deleted'),
                            this.$translate('checkoffType_role_delete_alert'),
                            'success',
                        )
                    })
                    .catch(error => {
                        console.log('error', error)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        saveRole() {
            const {
                model: { role_id },
                checkoffType: { id: checkoff_type_id },
            } = this

            // if the template exists add the master item to the template in the database or update it in the database
            const path = `checkoffTypes/createRole`

            this.loading = true
            this.$store
                .dispatch(path, { checkoff_type_id, role_id })
                .then(() => {
                    this.loading = false
                    this.itemModal = false
                    this.modelChanged = false
                    this.doToast(
                            this.$translate('created'),
                            this.$translate('checkoffType_role_create_alert'),
                            'success',
                        )
                })
                .catch(error => {
                    console.log('error', error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>
